import type { ApiRefusal } from "./refusal";

/** Thrown by `unwrap` so TanStack Query and error boundaries can see the typed refusal. */
export class ApiRefusalError extends Error {
  readonly refusal: ApiRefusal;

  constructor(refusal: ApiRefusal) {
    super(`${refusal.status} ${refusal.code}`);
    this.name = "ApiRefusalError";
    this.refusal = refusal;
  }
}

export function isApiRefusalError(value: unknown): value is ApiRefusalError {
  return value instanceof ApiRefusalError;
}
